export const FeedbackResponseType = {
  Thumbs: 'thumbs',
  Rating: 'rating',
  Options: 'options',
} as const;
export type FeedbackResponseType = (typeof FeedbackResponseType)[keyof typeof FeedbackResponseType];

export const FeedbackQuestionIds = {
  FactExtractionAccuracy: 'fact-extraction-accuracy',
  CitationPrecision: 'citation-precision',
  InconsistencyDetection: 'inconsistency-detection',
  KimAnswerAccuracy: 'kim-answer-accuracy',
  RealtimeFlagRelevance: 'realtime-flag-relevance',
  RealtimeSpeechAccuracy: 'realtime-speech-accuracy',
  UsabilityChronology: 'usability-chronology',
  UsabilityKimChronology: 'usability-kim-chronology',
  TimeSavings: 'time-savings',
} as const;
export type FeedbackQuestionIds = (typeof FeedbackQuestionIds)[keyof typeof FeedbackQuestionIds];

type FeedbackQuestionDef = {
  question: string;
  allowsFreeText: boolean;
} & (
  | { responseType: typeof FeedbackResponseType.Thumbs }
  | { responseType: typeof FeedbackResponseType.Rating; lowLabel: string; highLabel: string }
  | { responseType: typeof FeedbackResponseType.Options; options: string[] }
);

export const FEEDBACK_QUESTIONS: Record<FeedbackQuestionIds, FeedbackQuestionDef> = {
  [FeedbackQuestionIds.FactExtractionAccuracy]: {
    question: 'How accurate were these extracted facts?',
    responseType: FeedbackResponseType.Rating,
    lowLabel: 'Not accurate',
    highLabel: 'Very accurate',
    allowsFreeText: true,
  },
  [FeedbackQuestionIds.CitationPrecision]: {
    question: 'Did this citation take you to the right place?',
    responseType: FeedbackResponseType.Thumbs,
    allowsFreeText: false,
  },
  [FeedbackQuestionIds.InconsistencyDetection]: {
    question: 'Is this a real contradiction?',
    responseType: FeedbackResponseType.Options,
    options: ['Yes', 'No', 'Partially'],
    allowsFreeText: false,
  },
  [FeedbackQuestionIds.KimAnswerAccuracy]: {
    question: 'Was this Kim answer helpful?',
    responseType: FeedbackResponseType.Thumbs,
    allowsFreeText: true,
  },
  [FeedbackQuestionIds.RealtimeFlagRelevance]: {
    question: 'Did Real Time surface relevant inconsistencies?',
    responseType: FeedbackResponseType.Thumbs,
    allowsFreeText: false,
  },
  [FeedbackQuestionIds.RealtimeSpeechAccuracy]: {
    question: 'Would you use this in a real session?',
    responseType: FeedbackResponseType.Options,
    options: ['Yes', 'Not yet'],
    allowsFreeText: false,
  },
  [FeedbackQuestionIds.UsabilityChronology]: {
    question: 'How easy was it to build this chronology?',
    responseType: FeedbackResponseType.Rating,
    lowLabel: 'Very difficult',
    highLabel: 'Very easy',
    allowsFreeText: false,
  },
  [FeedbackQuestionIds.UsabilityKimChronology]: {
    question: 'Did this save you time vs. doing it manually?',
    responseType: FeedbackResponseType.Options,
    options: ['Yes', 'Somewhat', 'No'],
    allowsFreeText: false,
  },
  [FeedbackQuestionIds.TimeSavings]: {
    question: 'How much time do you think this saved?',
    responseType: FeedbackResponseType.Options,
    options: ['Less than 1 hour', '1 to 3 hours', '3 to 5 hours', '5+ hours'],
    allowsFreeText: false,
  },
};
